import { CustomerAsset } from '../../asset';
import { BidStatusEnum } from '../enums';
import { Listing } from './listing';

export interface Bid {
  id: string;
  listingId: string;
  status: BidStatusEnum;
  price: number;
  paymentExpireTime: string;
  rejectReason: string;
  reasonDescription: string;
  createdAt: string;
  createdBy: string;
  listing?: Listing;
  asset?: CustomerAsset;
}

export enum BidReasonsEnum {
  OTHER = 'Other',
  REJECT_REASON = 'rejectReason',
  REJECT_DESCRIPTION = 'rejectDescription',
}
